import React, { ChangeEvent, useState } from "react";
import SoundButtons from "./SoundButtons";
import { useSounds } from "../../hooks/UseSounds";
import config from "../../Config";

let audio = new Audio();

function playSoundLocally(sound: string) {
  audio.pause();
  audio = new Audio(`https://api.heg.cool/hegbot/soundboard/${sound}`);
  audio.play();
}

function playSoundOnServer(sound: string) {
  fetch(`${config.hegbotUrl}/sound_board/play`, {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    method: "POST",
    body: JSON.stringify({ text: sound }),
  });
}

export default function SoundBoard() {
  const [clips, setClips] = useState<string[]>([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [singleplayer, setSingleplayer] = useState(false);

  const handleSearch = (event: ChangeEvent) => {
    const search = (event.target as HTMLTextAreaElement).value;
    setSearchTerm(search);
  };

  useSounds(setClips);

  return (
    <>
      <p>
        <small>Singleplayer Mode:</small>
        <label className="switch">
          <input
            type="checkbox"
            onChange={() => setSingleplayer(!singleplayer)}
          />
          <span className="slider round" />
        </label>
      </p>
      <small>search:</small>
      <input
        size={50}
        id="search"
        type="text"
        onChange={(event) => handleSearch(event)}
      />
      <br />
      {clips && (
        <SoundButtons
          clips={clips}
          searchTerm={searchTerm}
          clickFunction={
            singleplayer
              ? (sound: string) => playSoundLocally(sound)
              : (sound: string) => playSoundOnServer(sound)
          }
        />
      )}
    </>
  );
}
